var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 8.49935H5.83301M7.33301 10.666L5.87345 9.20646C5.48292 8.81593 5.48292 8.18277 5.87345 7.79224L7.33301 6.33268M1.83301 8.49935C1.83301 5.09359 4.59392 2.33268 7.99967 2.33268C11.4054 2.33268 14.1663 5.09359 14.1663 8.49935C14.1663 11.9051 11.4054 14.666 7.99967 14.666C4.59392 14.666 1.83301 11.9051 1.83301 8.49935Z",
    stroke: "#926AF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.fd688b3948ceb0289096818e4d2f3b63.svg";
export { ForwardRef as ReactComponent };